import { render } from "./hero.vue?vue&type=template&id=5d6b39b7&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=5d6b39b7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d6b39b7"

export default script